import { render, staticRenderFns } from "./FileImage.vue?vue&type=template&id=3b99be13&"
import script from "./FileImage.vue?vue&type=script&lang=js&"
export * from "./FileImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports